export { buttons }

const buttons = [
  {
    id: 1,
    text: 'Women & Girls',
    tags: [15],
  },
  {
    id: 2,
    text: 'Disaster Recovery',
    tags: [5],
  },
  {
    id: 3,
    text: 'Children & Education',
    tags: [3, 7],
  },
  {
    id: 4,
    text: 'Health & Sanitation',
    tags: [9],
  },
  {
    id: 5,
    text: 'Environment',
    tags: [2, 4, 8],
  },
  {
    id: 6,
    text: 'Micro-Enterprise',
    tags: [6],
  },
]
